export default "__VITE_PUBLIC_ASSET__53c0a94c__"